import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { usePersistedState } from '../utils/Common';

export const MiscContext = createContext();


export const MiscProvider = ({ children }) => {
  const containerRef = useRef(null); 

    const [pwdAlert, setPwdAlert] = useState(false);
    const [titles, setTitles] = usePersistedState('titles', []);
    const [pp, setPp] = useState(false);
    const [isUploading, setIsUploading] = useState(false);  
    const [privacyData, setPrivacyData] = useState(undefined);  
    const [companiesMap,setCompaniesMap] = usePersistedState('companiesMap',[]);
    const [receipts, setReceipts]   = usePersistedState('receipts', []);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(undefined);
    const [dynamicMessageFromApiCall, setDynamicMessageFromApiCall] = usePersistedState('dynamicMessageFromApiCall',"");  
    const [contactPage,setContactPage]=usePersistedState('contactPage',false);
   
    const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);
    const [forgotUserIdModalOpen, setForgotUserIdModalOpen] = useState(false);
    const [testimonials, setTestimonials] = usePersistedState('testimonials',[]);  
    const [documentsMap, setDocumentsMap]= usePersistedState('documentsMap',{});
    const [lastRefreshTimestamp, setLastRefreshTimestamp] = usePersistedState(0);
 
  const[isDocumentsFetched, setIsDocumentsFetched] = useState(false);
  const[isCompaniesFetched, setIsCompaniesFetched] = useState(false);
  const [DPM, setDPM] = usePersistedState('DPM',localStorage.getItem('DPM'));  
  const [host, setHost]= usePersistedState('URL', window.location.hostname);
  

  const clearMiscState = useCallback(() => {
    setDynamicMessageFromApiCall(undefined);
    setTestimonials([]);
    setDocumentsMap([]);
    setContactPage(false);
    setReceipts([]);
    setCompaniesMap([]);
    setPp(false);
    setHost('');
    localStorage.removeItem("DPM"); 
}, [setCompaniesMap, setContactPage, setDocumentsMap, setDynamicMessageFromApiCall, setHost, setReceipts, setTestimonials]);


useEffect(() => {
    const handleBeforeUnload = (event) => {
      localStorage.setItem("DPM", "true"); 
    };
  
    window.addEventListener("beforeunload", handleBeforeUnload);  
    return () => {
        // Cleanup listener when component is unmounted
        window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const handleStorageChange = (e) => {
    if (e.key === "DPM") {
      setDPM(e.newValue);      
    }
  };
window.addEventListener('storage', handleStorageChange);

  const value = useMemo(() => ({
    dynamicMessageFromApiCall,setDynamicMessageFromApiCall,pp,setPp,isUploading, setIsUploading,privacyData, setPrivacyData,clearMiscState,lastRefreshTimestamp, setLastRefreshTimestamp, contactPage,setContactPage,isDocumentsFetched,
    setIsDocumentsFetched,isCompaniesFetched, setIsCompaniesFetched, DPM,setDPM,pwdAlert,setPwdAlert,forgotPasswordModalOpen,containerRef,titles, setTitles,host, setHost,
    setForgotPasswordModalOpen,setForgotUserIdModalOpen,forgotUserIdModalOpen,testimonials, setTestimonials,alertMessage, setAlertMessage,  documentsMap, setDocumentsMap,companiesMap,setCompaniesMap,receipts,setReceipts,showAlert,setShowAlert
  }), [dynamicMessageFromApiCall, setDynamicMessageFromApiCall, pp, isUploading, privacyData, clearMiscState, lastRefreshTimestamp, setLastRefreshTimestamp, contactPage, setContactPage, isDocumentsFetched, isCompaniesFetched, DPM, 
    setDPM, pwdAlert, forgotPasswordModalOpen, forgotUserIdModalOpen, testimonials, setTestimonials, alertMessage, documentsMap, setDocumentsMap, companiesMap, containerRef, setCompaniesMap, receipts, setReceipts, showAlert,titles, setTitles, host, setHost]);
  
  return (
    <MiscContext.Provider value={value}>
      {children}
    </MiscContext.Provider>
  );
};
MiscProvider.propTypes = {
 children: PropTypes.node,
  };
  
  